/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import PropTypes from "prop-types";

import { renderErrorMsg } from "../../../assets/component/renderErrorMsg.js";
import { mapPaymentMethodData } from "../../../assets/helper.js";
import "../RenderPaymentCode.css";

export default function RenderPaymentCode(props) {
  const { state, func, paymentMethod, showLabel = false } = props;

  let paymentMethodData = mapPaymentMethodData(
    state.organizationObj.paymentMethodCode,
    paymentMethod.key,
  );

  if (paymentMethodData) {
    const errMsg = state.errMsgInfo.paymentCode;

    if (errMsg.method === paymentMethod.key && errMsg.isCode) {
      paymentMethodData.error = errMsg.msg;
    }
  }

  paymentMethodData = {
    ...paymentMethodData,
    ...paymentMethod,
  };

  function paymentMethodView(method, showLabel) {
    const codeImage = method.code || "";

    const paymentCodeStyle = {
      backgroundImage: "url('" + codeImage + "')",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "90%",
      border: "none",
    };

    return (
      <div key={method.key}>
        <div className="RenderPaymentCode-uploader">
          <div className="RenderPaymentCode-input" style={paymentCodeStyle}>
            <input
              type="file"
              onChange={func.handleUploadPaymentCode}
              data-method={method.key}
              data-label={method.label}
              accept="image/png, image/jpeg"
            />
            {codeImage === "" && (
              <div className="RenderPaymentCode-inputText">
                {`Please upload your ${method.label} payment code`}
              </div>
            )}
          </div>
          {showLabel && (
            <div className="RenderPaymentCode-label">{method.label}</div>
          )}
        </div>
        {renderErrorMsg(method.error)}
      </div>
    );
  }

  return (
    <div className="RenderPaymentCode-container">
      {paymentMethodView(paymentMethodData, showLabel)}
    </div>
  );
}

RenderPaymentCode.propTypes = {
  func: PropTypes.object,
  state: PropTypes.object,
  paymentMethod: PropTypes.object,
  showLabel: PropTypes.bool,
};
